"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ direction, numberCircleColor, image }) => {
    const theme = (0, material_1.useTheme)();
    const containerStyle = {
        display: 'flex',
        width: '100%',
        background: theme.qlub.palette.white.main,
    };
    const cellStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '8px',
        width: '100%',
        padding: '16px 24px',
    };
    const headerCellStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '0px',
        gap: '8px',
        width: '100%',
        minHeight: '26px',
        '& .number': Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, backgroundColor: numberCircleColor || theme.qlub.palette.iris_light.hover, borderRadius: '100px', display: 'flex', justifyContent: 'center', alighItems: 'center', width: '24px', height: '24px', padding: '4px' }),
    };
    const detailCellStyle = {
        display: 'flex',
        flexDirection: direction,
        alignItems: 'flex-start',
        padding: '0px',
        gap: '8px',
        width: '100%',
        flex: '1 1',
    };
    const detailGridCellStyle = {
        display: 'block',
    };
    const infoCellStyle = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0px',
        gap: '4px',
        width: '100%',
        minHeight: '24px',
    };
    const headerText = Object.assign(Object.assign({}, theme.qlub.typography.title_md), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, width: '100%', minHeight: '26px' });
    const footerPriceCell = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',
        gap: '8px',
        width: '100%',
        minHeight: '26px',
    };
    const headerOldPrice = Object.assign(Object.assign({}, theme.qlub.typography.body_sm_strike), { color: theme.qlub.palette.onSurfaceColors.disabled });
    const headerPrice = Object.assign(Object.assign({}, theme.qlub.typography.title_md), { color: theme.qlub.palette.onSurfaceColors.highEmphasis });
    const detailsBoxStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '0px',
        gap: '8px',
        width: 'calc(100% - 114px)',
    };
    const detailsBoxGridStyle = {
        marginTop: '8px',
    };
    const badgeCellStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px',
        gap: '8px',
        width: '100%',
        height: '24px',
    };
    const mediaStyles = {
        width: '114px',
        height: image && '112px',
        borderRadius: '16px',
    };
    const subTitleStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.mediumEmphasis });
    const descriptionStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.disabled });
    const infoIconStyle = {
        color: theme.qlub.palette.onSurfaceColors.disabled,
    };
    const infoTextStyle = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.disabled, display: 'flex', alignItems: 'center', letterSpacing: '0.004em', width: '1', minHeight: '17px' });
    const selectionIndicatorBox = {
        display: 'flex',
        flexDirection: 'row',
        padding: '0px',
        height: '24px',
    };
    const lineColumn = {
        width: '8px',
        backgroundColor: 'transparent',
    };
    const lineColumnSelected = {
        backgroundColor: theme.qlub.palette.iris.main,
    };
    const footerPriceStyle = {
        display: 'flex',
        width: '100% ',
        flexDirection: direction === 'row' ? 'row-reverse' : 'row',
        justifyContent: direction === 'row' ? 'space-between !important' : 'flex-start',
        alignItems: 'center',
        gap: direction !== 'row' && '8px',
    };
    return {
        containerStyle,
        cellStyle,
        footerPriceCell,
        headerCellStyle,
        detailCellStyle,
        detailGridCellStyle,
        infoCellStyle,
        headerText,
        headerOldPrice,
        headerPrice,
        detailsBoxStyle,
        detailsBoxGridStyle,
        badgeCellStyle,
        mediaStyles,
        subTitleStyle,
        descriptionStyle,
        infoIconStyle,
        infoTextStyle,
        selectionIndicatorBox,
        lineColumn,
        lineColumnSelected,
        footerPriceStyle,
    };
};
exports.default = useStyle;
